module.exports = __webpack_public_path__ + "img/marketing_upgrade_page.6c9ad1eb.png";